<template>
  <div :class="size == 'large' ? 'large-box' : ''">
    <commonHeader :activityFrom="activityFrom"> </commonHeader>
    <div class="center-box" :class="size == 'large' ? 'large' : ''">
      <slot></slot>
    </div>
    <commonFooter></commonFooter>
  </div>
</template>

<script>
import CommonHeader from './commonHeader'
import CommonFooter from './commonFooter'
export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  props: ['size', 'activityFrom'],
  name: 'layoutContainer',
  mounted() {
    if (this.$route.query.promoter_id !== undefined) {
      window.localStorage.setItem('promoter_id', this.$route.query.promoter_id);
      window.localStorage.setItem('promote_type', this.$route.query.promote_type);
    }
  }
}
</script>

<style lang="scss" scoped>
.center-box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
}

.large-box {
  background: #fff;
}

.large {
  width: 100%;
  margin-top: 0;
  margin-bottom: 25px;
}
</style>
